import StaffLogin from '../views/staff/Login';
import StaffSignUp from '../views/staff/SignUp';
import StaffRecover from '../views/staff/Recover';
import StaffActivate from '../views/staff/Activate';

export default [
    {
        path: '/admin/login',
        name: 'staff-login',
        component: StaffLogin,
        alias: ['/admin', '/staff'],
        meta: {
            title: 'Admin - Login',
            isAdmin: true,
        },
    },
    {
        path: '/admin/sign-up',
        name: 'staff-sign-up',
        component: StaffSignUp,
        alias: '/admin/register',
        meta: {
            title: 'Admin - Sign Up',
            isAdmin: true,
        },
    },
    {
        path: '/admin/recover',
        name: 'staff-recover',
        component: StaffRecover,
        meta: {
            title: 'Admin - reset your password',
            isAdmin: true,
        },
    },
    {
        path: '/admin/activate/:token',
        name: 'staff-activate',
        component: StaffActivate,
        meta: {
            title: 'Admin - Activate account',
            isAdmin: true,
        },
    },
];
